<div class="new-product">


    <div class="card" [ngClass]="{'current':productData.currentPlan}" (click)="navigate()">

        <div class="price-table">
            <h2 *ngIf="productData.currentPlan" class="current-product-indicator">
                Plano atual
            </h2>
            <div class="card-header">

                <h2 class="card-title">{{productData.planName}}</h2>

                <div class="card-sub-title">
                    <p *ngIf="productData.currentPlan">
                        Valor utilizado até agora:
                    </p>
                    <p *ngIf="!productData.currentPlan">
                        Valor das próximas faturas:
                    </p>

                    <div class="product-installment">
                        <span *ngIf="productData.currentPlan">
                            <span class="product-installment-value"> R$
                                {{productData.consumedValue.toFixed(2).replace('.',',')}}</span>
                            <br>
                            <span class="product-installment-total">de : R$
                                <span style="font-weight: bold;">
                                    {{productData.planValue.toFixed(2).replace('.',',') }}
                                </span>
                            </span>
                        </span>
                        <span *ngIf="!productData.currentPlan">
                            {{productData.maxInstallment}}x<span class="product-installment-value"> R$
                                <span style="font-weight: bold;">
                                    {{productData.maxInstallmentValue.toFixed(2).replace('.',',')}}
                                </span>
                            </span>
                            <br>
                            <span class="product-installment-total">ou R$
                                <span style="font-weight: bold;">
                                    {{productData.planValue.toFixed(2).replace('.',',') }}
                                </span> à vista</span>
                            <p class="before-list-text"> Todos os benefícios do seu plano atual </p>
                        </span>
                    </div>

                </div>


            </div>
            <div class="list">
                <ul class="pme-product-feature-list" *ngIf="productData.featureList && productData.featureList.length">
                    <ng-container *ngFor="let feature of productData.featureList; let i = index">
                        <li *ngIf="i < visibleItems">
                            <div class="feature-item"
                                [ngStyle]="{'font-weight':!productData.currentPlan ? 'bold':'0', 'color':!productData.currentPlan ? 'black':''}">
                                <mat-icon
                                    [ngClass]="{'disabled': feature.icon === 'clear', 'highlight': feature.icon === 'verified'}">
                                    {{feature.icon}}
                                </mat-icon>
                                <div>
                                    {{feature.name}}
                                </div>
                            </div>
                        </li>
                    </ng-container>
                </ul>
            </div>
            <div *ngIf="productData.currentPlan">
                <button mat-button class="show-more-button firstLetter" (click)="toggleCollapse()">
                    <mat-icon>{{ isCollapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
                    <span class="firstLetter">{{ isCollapsed ? 'Ver todos os benefícios' : 'Ver menos' }}</span>
                </button>
            </div>

            <div style="display: flex;justify-content: center;">
                <button class="button-buy firstLetter" mat-raised-button s *ngIf="!productData.currentPlan"
                    (click)="navigate()" [id]="'btn-upgrade-' + productData.planIdentifier">
                    <span class="firstLetter">Selecionar plano</span></button>
            </div>
        </div>
    </div>

</div>
